import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, EASE } from "../site/motion";
import { SERVICES } from "../site/data";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-muted py-28 md:py-40 border-y border-border">
    <div className="mx-auto max-w-[1600px] px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-14 items-end">
        <Reveal className="md:col-span-8">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-secondary mb-4">What We Offer</p>
          <h2 className="font-serif font-light text-foreground text-4xl md:text-6xl">Comprehensive addiction medicine, under one roof.</h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-4">
          <p className="text-muted-foreground leading-relaxed">Nurse-led programs designed to keep you safe, supported and moving toward a life beyond dependency.</p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.title}
            data-testid={`service-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.08 }}
            whileHover={{ y: -6 }}
            className={`group ${s.span} bg-background border border-border p-8 md:p-12 flex flex-col justify-between min-h-[280px] md:min-h-[340px] cursor-default`}
          >
            <div className="flex items-start justify-between">
              <span className="font-serif text-3xl text-muted-foreground">0{i + 1}</span>
              <ArrowUpRight className="text-secondary opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300" />
            </div>
            <div>
              <h3 className="font-serif font-light text-foreground text-3xl md:text-4xl mb-4">{s.title}</h3>
              <p className="text-muted-foreground leading-relaxed max-w-md">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
